import Vue from 'vue';

// 使用 Event Bus
const color4 = new Vue();

export default color4;



// WEBPACK FOOTER //
// ./src/view/framework/home/color3.js